import React from 'react'

import { ContentfulSizeChartSection } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

import styles from '../sizeGuideV2.module.scss'

import UnitsToggleV2 from './UnitToggleV2'

interface SizeChartHeaderProps {
  headerTitle?: string
  onUnitsToggle: (index: number, selectedValue: string) => void
  selectedSizeChartSection?: ContentfulSizeChartSection
  sizeChartSections: ContentfulSizeChartSection[]
  activeUnitIndex: number
  hideUnitsTitle?: boolean
}

const SizeChartHeaderV2 = (props: SizeChartHeaderProps) => {
  const shouldShowUnitsToggle = props.sizeChartSections.length > 1

  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.headerTitle}>{props.headerTitle}</div>
        {shouldShowUnitsToggle && (
          <UnitsToggleV2
            sizeChartSections={props.sizeChartSections}
            activeUnitIndex={props.activeUnitIndex}
            onUnitsToggle={props.onUnitsToggle}
          />
        )}
      </div>
    </>
  )
}

export default SizeChartHeaderV2
